<template>
  <li class="drawer-item">
    <template v-if="disabled">
      <a class="link" href="javascript:void(0)" tabindex="-1" :disabled="disabled">
        <span>
          <img v-if="src" :src="image_src" class="icon" />
          <span class="text"><slot></slot></span>
        </span>
      </a>
    </template>
    <template v-else>
      <router-link class="link" :to="{name: to, query: query}" :target="target">
        <span>
          <img v-if="src" :src="image_src" class="icon" />
          <span class="text"><slot></slot></span>
        </span>
      </router-link>
    </template>
  </li>
</template>

<script>

export default {
  name: 'drawer-item',
  props: {
    src: {type: String},
    to: {type: String},
    query: {query: Object},
    target: {type: String},
    disabled: {type: String}
  },
  computed: {
    image_src () {
      return require('@/assets/images/header/' + this.src)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.drawer-item {
  width: 325px;
  margin: 20px;
  >.link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
    height: 100px;
    padding-top: 15px;
    padding-bottom: 15px;
    border-top: 1px dotted $secondary;
    border-bottom: 1px dotted $secondary;
    background-image: url('../../assets/images/icons/arrow-right-gray.svg');
    background-size: 8px 16px;
    background-position: right center;
    background-repeat: no-repeat;
    .icon {
      max-width: 64px;
      width: 100%;
      height: auto;
      vertical-align: middle;
      display: inline-block;
      margin-right: 10px;
    }
    .with-img & {
      border-top: none;
      height: 60px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  &.-double {
    .icon {
      vertical-align: top;
    }
    .text {
      padding-top: .4em;
      display: inline-block;;
    }
  }
  &.disabled {
    background-color: #cccccc;
    color: #9a9a9a;
    >.link {
      cursor: not-allowed;
      opacity: 0.3;
    }
  }
}
.with-img .drawer-item {
  width: 360px;
  margin: 0 20px;
  &:nth-last-of-type(1),
  &:nth-last-of-type(2) {
    margin: 0 20px;
  }
  &:nth-of-type(1),
  &:nth-of-type(2) {
    margin: 20px 20px 0;
    .link {
      border-top: 1px dotted $secondary;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/globals/DrawerItem.vue